import { baseService } from "service/base";

class DeploymentService {
  load() {
    return baseService.get("/api/deployments");
  }

  loadScheduled() {
    return baseService.get("/api/scheduled-deployments");
  }

  // eslint-disable-next-line max-params
  schedule(strategyId, targetIds, deployDate, endDate, deployNow) {
    return baseService.post("/api/scheduled-deployment", {
      deployDate,
      deployNow,
      endDate,
      strategyId,
      targetIds,
    });
  }

  // eslint-disable-next-line max-params
  edit(deploymentId, strategyId, targetIds, deployDate, endDate, deployNow) {
    return baseService.put("/api/scheduled-deployment", {
      deploymentId,
      deployDate,
      deployNow,
      endDate,
      strategyId,
      targetIds,
    });
  }

  delete(deploymentId) {
    return baseService.delete("/api/scheduled-deployment", { deploymentId });
  }
}

const deploymentService = new DeploymentService();

export { deploymentService };
